<div class="modal-header">
  <strong class="text-custom-theme bold fs-5 d-inline-block">{{ prefix }}</strong>
</div>
<form #form="ngForm" class="form-validate">
  <div class="modal-body">
    <div class="row mb-3 mt-4">
      <div class="col">
       <label class="form-label">ชื่อผู้ใช้งาน / Username</label>
        <input type="text" class="form-control" id="userName" name="userName" disabled  [(ngModel)]="userManageGroupDto.userName">
      </div>
      <div class="col">
        <label class="form-label ui-require">ชื่อ / FirstName</label>
        <input type="text" class="form-control" id="firstName" name="firstName"
               #firstName='ngModel' [(ngModel)]="userManageGroupDto.fname" required>
        @if (firstName.invalid && (firstName.touched || firstName.dirty)) {
          <custom-error *ngIf="firstName.hasError('required')" error="*จำเป็น"></custom-error>
        }
      </div>
      <div class="col">
        <label class="form-label ui-require">นามสกุล / SurName</label>
        <input type="text" class="form-control" id="surName" name="surName"
               [(ngModel)]="userManageGroupDto.lname" required
        #surName = 'ngModel'>
        @if (surName.invalid && (surName.touched || surName.dirty)) {
          <custom-error *ngIf="surName.hasError('required')" error="*จำเป็น"></custom-error>
        }
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        <label class="form-label">เบอร์ติดต่อ / Telephone</label>
        <input type="text" class="form-control" id="telephone" name="telephone"  [(ngModel)]="userManageGroupDto.telephoneNo">
      </div>
      <div class="col-6">
        <label class="form-label ui-require">อีเมล / Email</label>
        <input type="text" class="form-control" id="email" name="email" [(ngModel)]="userManageGroupDto.email"
               required
               [pattern]="emailPattern"
        #email = 'ngModel'>
        @if (email.invalid && (email.dirty || email.touched)) {
          <div class="invalid-feedback d-block">
            @if (email.errors?.['required']) {
              <div>กรุณากรอกอีเมล</div>
            }
            @if (email.errors?.['pattern']) {
              <div>อีเมลไม่ถูกต้อง</div>
            }
          </div>
        }
      </div>
    </div>
  </div>
  <div class="row mt-3 mb-4 pe-3">
    <div class="col-12 text-center">
      <button type="button" class="btn btn-custom btn-custom-theme mx-1 btn-main confirm-btn" (click)="save()">
        <i class="bi bi-send me-1"></i>
        บันทึก
      </button>
      <button type="button" class="btn btn-custom btn-light mx-1 btn-main confirm-btn" (click)="activeModal.close()">
        <i class="bi bi-x-lg me-1"></i>
        ยกเลิก
      </button>
    </div>
  </div>
</form>


